<template>
  <div id="echarts-container" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    userForms: {
      type: Array,
      required: true,
    },
    transitRecords: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      todayRates: {
        signinRate: 0,
        signoutRate: 0,
      },
      chartInstance: null, // 保存图表实例以便后续更新
    };
  },
  watch: {
    userForms: {
      handler(newVal) {
        if (newVal.length > 0 && this.transitRecords.length > 0) {
          this.renderChart();
        }
      },
      deep: true,
    },
    transitRecords: {
      handler(newVal) {
        if (this.userForms.length > 0 && newVal.length > 0) {
          this.renderChart();
        }
      },
      deep: true,
    },
  },
  mounted() {
    window.addEventListener("resize", this.resizeChart); // 添加窗口大小调整事件监听器
    this.$nextTick(() => {
      this.initChart(); // 初始化图表
      this.renderChart(); // 渲染初始图表
      this.fetchTodayRates(); // 获取当天的签到率和签离率
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart); // 移除窗口大小调整事件监听器
    if (this.chartInstance) {
      this.chartInstance.dispose(); // 销毁图表实例
    }
  },
  methods: {
    initChart() {
      const chartContainer = document.getElementById("echarts-container");
      if (chartContainer) {
        this.chartInstance = echarts.init(chartContainer);
      }
    },
    renderChart() {
      const totalCount = this.userForms.length;
      const signinCount = this.transitRecords.filter(
        (record) => record.action === "signin"
      ).length;
      const signoutCount = this.transitRecords.filter(
        (record) => record.action === "signout"
      ).length;

      // 计算签到率和签离率，并转换为百分比形式
      const signinRate = ((signinCount / totalCount) * 100).toFixed(2);
      const signoutRate = ((signoutCount / totalCount) * 100).toFixed(2);
      // 确保签到率和签离率不超过100%
      this.todayRates.signinRate = Math.min(parseFloat(signinRate), 100);
      this.todayRates.signoutRate = Math.min(parseFloat(signoutRate), 100);
      this.updateBarChart(signinRate, signoutRate);
    },
    fetchTodayRates() {
      this.$http
        .get("/api/today-signin-signout-rates")
        .then((response) => {
          if (response.success) {
            this.todayRates.signinRate = response.data.signinRate;
            this.todayRates.signoutRate = response.data.signoutRate;
            this.updateTodayRatesChart();
          } else {
            this.$message.error("获取签到率和签离率失败");
          }
        })
        .catch((error) => {
          console.error("There was an error fetching rates!", error);
          this.$message.error("请求失败，请检查网络连接");
        });
    },
    updateBarChart(signinRate, signoutRate) {
      const option = {
        title: {
          text: "签到率和签离率",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["签到率", "签离率"],
          orient: "vertical",
          left: "left",
        },
        xAxis: {
          type: "category",
          data: ["今日签到率", "今日签离率"],
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            interval: 0,
            margin: 8,
          },
        },
        yAxis: {
          type: "value",
          max: 100, // 设置最大值为100%
          axisLabel: {
            formatter: "{value}%",
          },
        },
        series: [
          {
            name: "签到率",
            type: "bar",
            data: [parseFloat(signinRate)],
          },
          {
            name: "签离率",
            type: "bar",
            data: [parseFloat(signoutRate)],
          },
        ],
      };

      if (this.chartInstance) {
        this.chartInstance.setOption(option);
      }
    },
    updateTodayRatesChart() {
      const option = {
        title: {
          text: "今日签到率和签离率",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["今日签到率", "今日签离率"],
          orient: "vertical",
          left: "left",
        },
        xAxis: {
          type: "category",
          data: ["今日签到率", "今日签离率"],
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            interval: 0,
            margin: 8,
          },
        },
        yAxis: {
          type: "value",
          max: 100, // 设置最大值为100%
          axisLabel: {
            formatter: "{value}%",
          },
        },
        series: [
          {
            name: "今日签到率",
            type: "bar",
            data: [this.todayRates.signinRate],
          },
          {
            name: "今日签离率",
            type: "bar",
            data: [this.todayRates.signoutRate],
          },
        ],
      };

      if (this.chartInstance) {
        this.chartInstance.setOption(option);
      }
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
  },
};
</script>

<style scoped>
/* 确保图表占据整个容器 */
#echarts-container {
  width: 100%;
  height: 100%;
}
</style>
